/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caseslistempty2Inputs */

const en_caseslistempty2 = /** @type {(inputs: Caseslistempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have any cases yet.`)
};

const pt_caseslistempty2 = /** @type {(inputs: Caseslistempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não tem casos.`)
};

/**
* | output |
* | --- |
* | "You don't have any cases yet." |
*
* @param {Caseslistempty2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const caseslistempty2 = /** @type {((inputs?: Caseslistempty2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caseslistempty2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_caseslistempty2(inputs)
	return pt_caseslistempty2(inputs)
});
export { caseslistempty2 as "casesListEmpty" }